import { render, staticRenderFns } from "./Dialog_AddPowerTemplate.vue?vue&type=template&id=836c73d2&scoped=true&"
import script from "./Dialog_AddPowerTemplate.vue?vue&type=script&lang=js&"
export * from "./Dialog_AddPowerTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836c73d2",
  null
  
)

export default component.exports